// Copyright Epic Games, Inc. All Rights Reserved.

import { all, AllEffect } from "@redux-saga/core/effects";
import { watchInstallation } from "./installation/sagas";

export function* rootSaga(): Generator<AllEffect<Generator>> {
  yield all([watchInstallation()]);
}
